import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { PageWidthService } from './../../../services/page-width.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-buttons-preview-generate',
	templateUrl: './buttons-preview-generate.component.html',
	styleUrls: ['./buttons-preview-generate.component.scss']
})
export class ButtonsPreviewGenerateComponent implements OnInit, OnDestroy {
	@Input() componentData;
	@Input() refresh;
	@Input() refreshType;
	@Input() disableSave;
	@Input() refreshText;
	@Output() generateComponent = new EventEmitter<any>();
	@Output() updatePreview = new EventEmitter<any>();
	@ViewChild('createButtonsPadding', { static: true }) createButtonsPadding: ElementRef;
	padSubscription: Subscription;

	constructor(private pageWidthService: PageWidthService, private renderer: Renderer2) {}

	ngOnInit() {
		this.padSubscription = this.pageWidthService.refreshWidth.subscribe((width: number) => {
			this.renderer.setStyle(this.createButtonsPadding.nativeElement, 'margin', `0 0 0 ${width}px`);
		});
	}

	ngOnDestroy() {
		this.padSubscription.unsubscribe();
	}

	saveComponent(event) {
		this.generateComponent.emit(event);
	}

	renderWidget(event) {
		this.updatePreview.emit(event);
	}
}
